import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiButton } from '@taiga-ui/core';
import { TuiPagination } from '@taiga-ui/kit';
import { EmblaCarouselDirective } from 'embla-carousel-angular';
import { SharedModule } from '@src/app/shared';

import { ImagesCarouselComponent } from './images-carousel.component';

@NgModule({
  declarations: [ImagesCarouselComponent],
  imports: [CommonModule, SharedModule, EmblaCarouselDirective, TuiButton, TuiPagination],
  exports: [ImagesCarouselComponent],
})
export class ImagesCarouselModule {}
